const state = {
    update_id:0,
    request_id:0,
    quest_id:0,
}
const getters = {
    update_id: state => state.update_id,
    request_id: state => state.request_id,
    quest_id: state => state.quest_id,
}
const mutations = {
    currentUpdateId(state, update) {
        state.update_id = update
    },
    currentRequestId(state, update) {
        state.request_id = update
    },
    currentQuestId(state, update) {
        state.quest_id = update
    },
  };
const actions = {
    setUpdateId({commit}, update_id) {
        commit('currentUpdateId',update_id)
    },
    setRequestId({commit}, request_id) {
        commit('currentRequestId',request_id)
    },
    currenQuestIdAction({commit}, quest_id) {
        commit('currentQuestId',quest_id)
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
